import * as tslib_1 from "tslib";
import { FormGroup } from '@angular/forms';
export function getErrors(formGroup) {
    var result = formGroup.errors || {};
    if (formGroup.valid)
        return null;
    Object.keys(formGroup.controls).forEach(function (key) {
        var ctrl = formGroup.get(key);
        if (ctrl instanceof FormGroup) {
            var subErrors = getErrors(ctrl);
            result = tslib_1.__assign({}, result, subErrors);
        }
        else if (!ctrl.valid) {
            result[key] = ctrl.errors;
        }
    });
    return result;
}
/*
  Loops through each child component for the given FormGroup executing callback (cb).
 */
export function forEachChild(formGroup, cb) {
    Object.keys(formGroup.controls).forEach(function (k) {
        var control = formGroup.controls[k];
        cb(control, k);
        if (control instanceof FormGroup) {
            forEachChild(control, cb);
        }
    });
}
export function scrollToError(document, fieldSelector, errorSelector) {
    if (fieldSelector === void 0) { fieldSelector = 'mat-form-field,.ap-button-toggle-group,.ap-form-field'; }
    if (errorSelector === void 0) { errorSelector = '.mat-error,.ap-error-message'; }
    var formFields = document.querySelectorAll(fieldSelector);
    var foundError = false;
    formFields.forEach(function (element) {
        if (!foundError && element.querySelector(errorSelector) != null) {
            foundError = true;
            element.scrollIntoView({ behavior: 'smooth' });
        }
    });
    return foundError;
}
export function isModelNullOrEmpty(model) {
    var e_1, _a;
    if (model == null) {
        return true;
    }
    try {
        for (var _b = tslib_1.__values(Object.entries(model)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = tslib_1.__read(_c.value, 2), key = _d[0], value = _d[1];
            if (value != null) {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
}
